// @flow

import { type AppValues } from '@tectonics/app-values';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function indiaOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
  appValues: AppValues,
  outgoingPayment: $Shape<OutgoingPayment>,
): $Shape<OutgoingPayment> {
  return {
    country: 'in',
    name: userInputValues['indiaCustomerName'],
    phone_number: userInputValues['indiaPhoneNumber'],
    metadata: {
      ...outgoingPayment.metadata,
      upi_vpa: userInputValues['indiaUpiId'] !== undefined ? userInputValues['indiaUpiId'] : '',
    },
    zipcode: userInputValues['indiaZipcode'],
    state: userInputValues['indiaState'],
    address: userInputValues['indiaAddress'],
    street_complement: userInputValues['indiaStreetComplement'],
    street_number: userInputValues['indiaStreetNumber'],
    city: userInputValues['indiaCity'],
  };
}
